import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "热门推荐", href: "#hot" },
  { label: "动漫分类", href: "#category" },
  { label: "最新更新", href: "#update" },
  { label: "连播专区", href: "#binge" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!keyword.trim()) return;
    document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" });
    setKeyword("");
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md card-shadow" : "bg-transparent"
      }`}
    >
      <div className="container-site flex h-16 items-center justify-between gap-4">
        <a href="#home" className="flex shrink-0 items-center gap-2">
          <span className="grid h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-xl" />
          </span>
          <span className="font-heading text-2xl leading-none text-foreground-950">
            漫途动漫
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <form
            onSubmit={handleSearch}
            className="flex h-10 items-center overflow-hidden rounded-full border border-background-200 bg-background-100 focus-within:border-primary-400"
            aria-label="站内搜索"
          >
            <i className="ri-search-line pl-3 text-sm text-foreground-500" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索想看的动漫"
              className="h-full w-40 bg-transparent px-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="mr-1 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1.5 text-xs text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </form>
          <a
            href="#binge"
            className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-4 text-sm text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-play-circle-line" />
            立即开刷
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 shrink-0 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-800 md:hidden"
          aria-label="展开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="container-site flex flex-col gap-1 py-3" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <form onSubmit={handleSearch} className="mt-2 flex h-11 items-center overflow-hidden rounded-full border border-background-200 bg-background-100">
              <i className="ri-search-line pl-4 text-sm text-foreground-500" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索想看的动漫"
                className="h-full flex-1 bg-transparent px-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
              <button
                type="submit"
                className="mr-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50"
              >
                搜索
              </button>
            </form>
          </nav>
        </div>
      )}
    </header>
  );
}